<template>
  <div class="main-container">
    <tl-header type="h1">
      <div>Variable Earnings and Deductions</div>
      <template slot="icon" v-if="!showIntro">
        <div class="row-container">
          <div class="showIntro">
            <img class="imgClass" src="@/assets/questionmark.png" />
          </div>
        </div>
      </template>
    </tl-header>
    <div>
      <div class="row-container center">
        <div class="company-info" v-show="showIntro">
          <img class="image" src="@/assets/team.svg" />
          <div v-on:click="hideIntro">
            <img class="closeImage" src="@/assets/close.png" />
          </div>
          <div class="fontStyle">
            <span>Employee’s monthly variable earnings and deductions can be input here. Choose the employee and the salary component against which variable value is to be input.</span>
          </div>
        </div>
      </div>
      <div>
        <variable-earnings />
      </div>
    </div>
  </div>
</template>

<script>
import VariableEarnings from "./variableearnings.vue";
export default {
  name: "variableearningsIntro",
  components: { VariableEarnings },
  data() {
    return {
      showIntro: true
    };
  },
  methods: {
    /** to hide the intro screen if paygroups available */
    hideIntro() {
      this.showIntro = false;
    },
    /** to show the intro screen if paygroups are not available */
    goToIntro() {
      this.showIntro = true;
    },
    /** Navigation */
    cancel() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/introPage.scss";
.line {
  border-bottom: 1px solid #34c0be;
  flex-grow: 1;
  margin-top: 15%;
}
.btnGrp {
  float: right;
}
</style>
